export enum Path {
  Home = '/',
  Login = '/login',
  Profile = '/profile',
  ErrorPage = '/error',
  Document = '/document/:slug',
  PasswordRecover = '/password-recover',
  PasswordReset = '/reset-password',
  MailChangeStatus = '/mail-change-status',
  Invitation = `/register`,


  Performance = '/performance',
  Partners = '/partners',
  Partner = '/partners/:partnerId',
  AddPartner = '/partners/add',
  EditPartner = '/partners/:partnerId/edit',
  Hole = '/courses/:courseId/holes/:holeId',
  Courses = '/courses',
  Course = '/courses/:courseId',
  EditCourse = '/courses/:courseId/edit',
  Devices = '/devices',
  Device = '/devices/:deviceId',
  Gameplay = '/gameplay',
  Players = '/players',
  Player = '/players/:playerId',
  Users = '/users',
  User = '/users/:userId',
  AddCourse = `${Path.Courses}/add`,
}

export enum NavBarLinks {
  Performance = Path.Performance,
  Partners = Path.Partners,
  Courses = Path.Courses,
  Devices = Path.Devices,
  Gameplay = Path.Gameplay,
  Players = Path.Players,
  Users = Path.Users,
}
